import React, { useState, useContext, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const LicenseHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);

  const doClose = () => setOpen(false);

  useEffect(() => {
    return actions.recv("open-help", function () {
      setOpen(true);
    });
  }, []);
  return open !== true ? null : (
    <Modal
      title="License Status"
      onClose={doClose}
      content={() => (
        <>
          <p>List of licenses installed locally in the BQN server.</p>
          <ul>
          <li><b>FEATURE</b>: Functionality enabled by the license, for example TCP Acceleration (BTA).</li>
          <li><b>EXPIRATION</b>: Expiration date.</li>
          <li><b>CAPACITY</b>: Capacity limit in Mbps (1000000 bits per second).</li>
          <li><b>VALID</b>: License validity.</li>
        </ul>
        <p>Press the <i class="material-icons valign-icon">more_vert</i> icon and then select the <b>Load...</b> option to upload a new license file provided by Bequant.</p>
        <p>Click on the <i class="material-icons valign-icon">refresh</i> to refresh license information.</p>
        </>
      )}
    />
  );
};
export default LicenseHelpModal;